<template>
  <div class="container orderTrack" :data-corp-id="corpId">
      <div class="product_des">
        <div class="img_box">
          <img :src="express.cover" alt="">
          <!-- <p v-if="express.totalCount">{{express.totalCount}}件商品</p> -->
        </div>
        <ul class="des">
          <li>
            <label>物流状态：</label>
            <span class="status">{{trackStatus}}</span>
          </li>
          <li>
            <label>物流公司：</label>
            <span>{{express.name}}</span>
          </li>
          <li>
            <label class="num">运单号：</label>
            <span>{{express.nu}}</span>
          </li>
          <li>
            <label>共{{express.totalCount}}件商品</label>
          </li>
        </ul>
      </div>
      <div class="track_info" v-if="trackData.length>0">
        <p class="line-title">服务进度跟踪</p>
         <timeline>
          <timeline-item v-for="item in orderTrack.data">
            <h4 class="recent">{{item.context}}</h4>
            <p class="recent">{{item.time}}</p>
          </timeline-item>
        </timeline>
      </div>
      <div class="track_noData" v-if="!loading&&trackData.length==0">
         <img src="../../assets/img/no_track_icon.png" alt="">
         <p>暂时查询不到物流信息</p>
         <p class="tel">请咨询客服：400-6033-334</p>
      </div>
      <home :ishome=0></home>
  </div>
</template>
<script>

import  Timeline  from 'vux/src/components/timeline/timeline.vue'
import  TimelineItem  from 'vux/src/components/timeline/timeline-item.vue'

import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'
export default {
  data () {
    return {
     	loading:true,
      express:{
        cover:'',
        name:'',
        nu:'',
        totalCount:''
      },
      trackData:[]
    }
  },
  components:{
    Timeline, 
    TimelineItem,
    home
  },
  computed:{   	 	 
  	 ...mapGetters({
      orderTrack:'getorderTrack',
      getUserInfo: 'getUserInfo',
    }),  
    corpId(){
      return this.getUserInfo.corpId || '';
    },
    trackStatus(){
      let text="已发货"
      if(this.orderTrack.express&&(this.orderTrack.express.state==3||this.orderTrack.express.state==4)){
        text="已签收"
      }
      return text;
    }

  },
  watch:{
    orderTrack(cval){
      if(cval){
        this.loading=false;
        Object.assign(this.express,cval.express)
        Object.assign(this.trackData,cval.data)
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时恢复默认标题
    this.$store.commit('CORP_CUSTOMIZE_ATTR', {
      data: {
        key: 'page_title_default',
        value: ''
      }
    })
  },
  created(){
   
    this.$store.dispatch('loadOrderTrack',{orderId:this.$route.query.orderId,type:this.$route.query.type})
  },
  methods:{

  },
  mounted(){
    this.$store.commit('CORP_CUSTOMIZE_ATTR', { 
        data: { 
          key: 'page_title_default', 
          value: '物流信息',
        } 
    })
  }
}
</script>